module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    style: (_vm.styleObject),
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('colgroup', _vm._l((_vm.columns), function(column, columnIndex) {
    return _c('col', {
      key: columnIndex,
      attrs: {
        "width": _vm.setCellWidth(column, columnIndex, false)
      }
    })
  }), 0), _vm._v(" "), _c('tbody', {
    class: [_vm.prefixTableClass + '-tbody']
  }, [_vm._l((_vm.data), function(row, rowIndex) {
    return [_c('t-table-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!row._isHidden),
        expression: "!row._isHidden"
      }],
      key: (row._loopKey || ("r" + rowIndex)),
      ref: ("tableRow" + rowIndex),
      refInFor: true,
      attrs: {
        "prefix-table-class": _vm.prefixTableClass,
        "tree-data": _vm.treeData,
        "fixed": _vm.fixed,
        "row": row,
        "columns": _vm.columns,
        "all-ellipsis": _vm.allEllipsis
      },
      on: {
        "row-height-correction": _vm.rowHeightCorrection
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$_onRowClick(row._index)
        },
        "dblclick": function($event) {
          $event.stopPropagation();
          return _vm.$_onRowDBLClick(row._index)
        }
      }
    }), _vm._v(" "), (_vm.isExpandrow && !row._disableExpand) ? [_c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row._isExpanded),
        expression: "row._isExpanded"
      }],
      key: (row._loopKey || ("exp-tr" + rowIndex)),
      class: _vm.prefixTableClass + '__row--expanded'
    }, [_c('td', {
      attrs: {
        "colspan": _vm.columns.length,
        "id": ("exp" + rowIndex)
      }
    }, [_c('expand', {
      key: (row._loopKey || ("exp" + rowIndex)),
      ref: "expandRow",
      refInFor: true,
      attrs: {
        "row": row,
        "render": _vm.expandRender,
        "index": row._index
      }
    })], 1)])] : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5eeba92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/table-body.vue
// module id = 418
// module chunks = 0